import React from "react";
import PropTypes from "prop-types";
import ToggleSwitch from "../../shared/toggle-switch";

const TradeInYourCarToggleButton = ({
    tradeInToggleSelected,
    setTradeInToggleSelectedConnect,
    onTradeInSelectCallback = () => {}
}) => {

    const onTradeInSelectHandler = () => {
        setTradeInToggleSelectedConnect(!tradeInToggleSelected);
        onTradeInSelectCallback();
    };

    return (
        <React.Fragment>
            <ToggleSwitch onChangeCallback={onTradeInSelectHandler} checked={tradeInToggleSelected}/>
        </React.Fragment>
    );
};

TradeInYourCarToggleButton.propTypes = {
    tradeInToggleSelected: PropTypes.bool,
    setTradeInToggleSelectedConnect: PropTypes.func,
    onTradeInSelectCallback: PropTypes.func
};

export default TradeInYourCarToggleButton;
